import React, { useEffect } from 'react';
import MLSShow from '../MLS/MLSShow';

export default function MLSShowModal({ listingURL, isModal, closeModal, areas }) {
  const splitURL = listingURL?.split('-');

  useEffect(() => {
    if (!window.localStorage.getItem('prevUrl')) {
      window.localStorage.setItem(
        'prevUrl',
        `${window.location.origin}/for-sale?type=Residential&listing_statuses=Active,Coming%20Soon`
      );
    }
  }, []);

  return (
    <>
      <div className="modal-container">
        <div
          className="modal-backdrop"
          onClick={closeModal}
          role="presentation"
        />

        <aside className="mls-show-modal">
          <MLSShow
            listing_id={splitURL[splitURL.length - 1]}
            isModal={isModal}
            closeModal={closeModal}
            areas={areas}
          />
        </aside>
      </div>
      <div id="mls-inquiry-modal-portal" />
      <div id="mls-share-modal-portal" />
    </>
  );
}
